import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
// import CustomPageIcon from '@material-ui/icons/Assignment';
// import DirectLinkPageIcon from '@material-ui/icons/Link';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
// import FolderIcon from '@material-ui/icons/Folder';
// import ListSubheader from '@material-ui/core/ListSubheader';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import toJS from '../../../lib/hocs/toJS';
// import { heapTrack } from '../../../lib/functions/utils';
import requestsManagerAxios from '../../../lib/requestsManagerAxios';

const styles = theme => {
  return {
    drawerPaper: {
      backgroundColor: theme.palette.primary.main,
    },
    listColor: {
      color: theme.palette.primary.contrastText,
    },
    toolbar: {
      justifyContent: 'space-between',
    },
  };
};

const FirstLevelPage = withStyles(styles)(
  ({ title, type, link, classes, openInNewTab }) => (
    <ListItem
      button
      component="a"
      href={link}
      target={openInNewTab ? '_blank' : '_self'}
    >
      {/*<ListItemIcon className={classes.listColor}><Icon type={type} /></ListItemIcon>*/}
      <ListItemText classes={{ primary: classes.listColor }} primary={title} />
    </ListItem>
  )
);

const SecondLevelPage = withStyles(styles)(
  ({ title, type, link, classes, openInNewTab }) => (
    <ListItem
      button
      component="a"
      href={link}
      classes={{ container: classes.listColor }}
      style={{ paddingLeft: 32 }}
      target={openInNewTab ? '_blank' : '_self'}
    >
      {/*<ListItemIcon className={classes.listColor}><Icon type={type} /></ListItemIcon>*/}
      <ListItemText classes={{ primary: classes.listColor }} primary={title} />
    </ListItem>
  )
);

class FolderUnwrapped extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      folderOpen: false,
    };
  }

  render() {
    const { title, pages, type, classes } = this.props;
    return (
      <React.Fragment>
        <ListItem
          button
          onClick={() => this.setState({ folderOpen: !this.state.folderOpen })}
          className={classes.listColor}
        >
          {/*<ListItemIcon className={classes.listColor}><FolderIcon /></ListItemIcon>*/}
          <ListItemText
            classes={{ primary: classes.listColor }}
            primary={title}
          />
          {this.state.folderOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state.folderOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {pages.map(
              page =>
                page.isActive && (
                  <SecondLevelPage
                    title={page.title}
                    key={page.id}
                    type={page.type}
                    link={page.link}
                    openInNewTab={page.open_in_new_tab}
                  />
                )
            )}
          </List>
        </Collapse>
      </React.Fragment>
    );
  }
}

const Folder = withStyles(styles)(FolderUnwrapped);

const folderHasActiveChildren = children => {
  let hasAtLeastOneActiveChild = false;
  children.forEach(child => {
    if (child.isActive) hasAtLeastOneActiveChild = true;
  });
  return hasAtLeastOneActiveChild;
};

class HeaderMobile extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      drawerOpen: false,
    };
  }

  handleToggleDrawer = () =>
    this.setState({ drawerOpen: !this.state.drawerOpen });

  renderDrawer() {
    const { classes, isEditingOrganization } = this.props;
    return (
      <div>
        <div />
        <Divider />
        {/*<List subheader={<ListSubheader component="div" className={classes.listColor}>Pages</ListSubheader>}>*/}
        <List>
          {this.props.navbarItems.map(navbarItem =>
            navbarItem.type === 'FolderPage'
              ? navbarItem.isActive &&
                (isEditingOrganization ||
                  folderHasActiveChildren(navbarItem.children)) && (
                  <Folder
                    key={navbarItem.id}
                    title={navbarItem.title}
                    type={navbarItem.type}
                    pages={navbarItem.children}
                    isEditingOrganization={isEditingOrganization}
                  />
                )
              : navbarItem.isActive && (
                  <FirstLevelPage
                    key={navbarItem.id}
                    title={navbarItem.title}
                    type={navbarItem.type}
                    link={navbarItem.link}
                    openInNewTab={navbarItem.open_in_new_tab}
                  />
                )
          )}
          {this.props.isEditingOrganization && (
            <React.Fragment>
              <Divider />
              <ListItem button component="a" href="/admin/pages">
                <ListItemText
                  inset
                  classes={{ primary: classes.listColor }}
                  primary="Add/Edit Pages"
                />
              </ListItem>
            </React.Fragment>
          )}
        </List>
      </div>
    );
  }

  renderSigninButton() {
    if (this.props.isUserSignedIn) {
      if (this.props.canEditOrganization) return null;
      // return (
      //   <Button
      //     color="inherit"
      //     href="/admin/dashboard"
      //     onClick={() => heapTrack('Organizer Clicked Dashboard From Mobile')}
      //   >
      //     Dashboard
      //   </Button>
      // );
      return (
        <Button
          onClick={() => {
            requestsManagerAxios
              .delete('/users/sign_out')
              .then(() => {
                window.location = '/';
              })
              .catch(() => {
                window.location.reload();
              });
          }}
          color="inherit"
        >
          Sign Out
        </Button>
      );
    }
    return (
      <Button color="inherit" href="/signin">
        Admin
      </Button>
    );
  }

  render() {
    return (
      <div>
        <AppBar position="static" color="primary">
          <Toolbar className={this.props.classes.toolbar}>
            {!this.props.isEditingOrganization &&
            this.props.navbarItems.length === 0 ? (
              <div>&nbsp;</div>
            ) : (
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleToggleDrawer}
              >
                <MenuIcon />
              </IconButton>
            )}
            {this.renderSigninButton()}
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            variant="temporary"
            anchor="left"
            open={this.state.drawerOpen}
            onClose={this.handleToggleDrawer}
            classes={{
              paper: this.props.classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {this.renderDrawer()}
          </Drawer>
        </nav>
      </div>
    );
  }
}

HeaderMobile.propTypes = {
  navbarItems: PropTypes.array.isRequired,
};
HeaderMobile.defaultProps = {};

export default withStyles(styles)(toJS(HeaderMobile));
